import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';

import { isScrollingDisabled } from '../../ducks/ui.duck';
import { hubPageSchema } from '../../util/landingSchema';

import LandingLayout from './LandingLayout';
import { CATEGORIES } from './landingContent';
import Hero from './sections/Hero';
import ClaimBanner from './sections/ClaimBanner';
import CardGrid from './sections/CardGrid';
import Usps from './sections/Usps';
import FinalCta from './sections/FinalCta';

// Copy ported verbatim from the old toastably-web/kategorie/index.html. This
// page ranks; rewording it is not part of moving it into the app.
const DESCRIPTION =
  'Alle Kategorien auf Toastably: Location, Catering, Fotografie, Musik, Dekoration, Beauty, Transport und mehr. Findet die passenden Anbieter:innen für eure Hochzeit in der Schweiz.';

export const CategoryHubPageComponent = props => {
  const { scrollingDisabled } = props;

  return (
    <LandingLayout
      title="Alle Kategorien – Hochzeitsanbieter:innen in der Schweiz | Toastably"
      description={DESCRIPTION}
      schema={hubPageSchema(
        'Kategorien',
        '/kategorie/',
        CATEGORIES.map(c => ({ name: c.label, path: `/kategorie/${c.slug}/` }))
      )}
      currentPage="CategoryHubPage"
      scrollingDisabled={scrollingDisabled}
    >
      <Hero
        crumbs={[{ label: 'Startseite', link: { name: 'LandingPage' } }, { label: 'Kategorien' }]}
        heading="Alle Kategorien"
        primaryCta={{ link: { name: 'SearchPage' }, label: 'Jetzt Angebote entdecken' }}
      />

      <CardGrid
        id="cats-title"
        ariaLabel="Alle Kategorien"
        items={CATEGORIES.map(c => ({
          key: c.slug,
          link: { name: 'CategoryLandingPage', params: { slug: c.slug } },
          label: c.label,
          image: c.image,
        }))}
      />

      <ClaimBanner />
      <Usps />

      <FinalCta
        heading="Findet eure Hochzeitsdienstleister:innen"
        text="Vergleicht Angebote aus der ganzen Schweiz und bucht direkt über die Plattform."
        link={{ name: 'SearchPage' }}
        label="Jetzt Angebote entdecken"
      />
    </LandingLayout>
  );
};

const mapStateToProps = state => ({ scrollingDisabled: isScrollingDisabled(state) });

export default compose(connect(mapStateToProps))(CategoryHubPageComponent);
